// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".version-import-growl-body {\n\tmargin-right: 20px;\n}\n\n.version-import-growl-body button {\n\tmargin-top: 8px;\n}\n", "",{"version":3,"sources":["VersionImportErrorGrowl.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB","file":"VersionImportErrorGrowl.css","sourcesContent":[".version-import-growl-body {\n\tmargin-right: 20px;\n}\n\n.version-import-growl-body button {\n\tmargin-top: 8px;\n}\n"]}]);
// Exports
module.exports = exports;
